export const CITIES = [
  'BOITUVA',
  'CAPELA DO ALTO',
  'CERQUILHO',
  'IPERÓ',
  'SOROCABA',
  'TIETÊ',
];

export const CONTRACT_FIXED_PAYLOAD = {
  uf: 'SP',
  pais: 'BR',
  senha: '210',
  portador_id: 1,
  contrato_id: 100022,
  central_senha: '210',
  modoaquisicao: 1,
  midia_id: 100040,
  tecnico_id: 32,
  os_instalacao: 'True',
  instalacao_quantidade_parcelas: 0,
  instalacao_preco: 0,
  instalacao_desconto: 0,
  instalacao_entrada: 0,
  instalacao_entrada_forma: 1,
  instalacao_parcela_forma: 1,
  formacobranca_id: 1,
  precadastro_ativar: 1,
};

export function generateLogin16(): string {
  const chars = '0123456789abcdef';
  let out = '';
  for (let i = 0; i < 16; i++) out += chars[Math.floor(Math.random() * chars.length)];
  return out;
}

export function buildServicoDesc(planDesc: string, paInternet: number, paTv: number): string {
  const parts: string[] = [];
  if (planDesc) parts.push(planDesc);
  if (paInternet > 0) parts.push(`${paInternet}x P.A Internet`);
  if (paTv > 0) parts.push(`${paTv}x P.A TV`);
  return parts.join(' + ');
}

export function calculateMonthly(planValor: number, paInternet: number, paTv: number): number {
  const internetAdd = paInternet * 50;
  const tvAdd = paTv > 0 ? 25 + (paTv - 1) * 15 : 0;
  return planValor + internetAdd + tvAdd;
}
